/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_SubtitleInputs */



/**
* | output |
* | --- |
* | "A desktop app is asking to sign in to your oneAI account." |
*
* @param {Auth_Device_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_subtitle = /** @type {((inputs?: Auth_Device_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Desktop-App möchte sich bei deinem oneAI-Konto anmelden.")
	return /** @type {LocalizedString} */ ("A desktop app is asking to sign in to your oneAI account.")
});